export default __webpack_public_path__ + "static/media/img_01.000eb98d.png";